import { z } from "zod";
import { languageSchema, submissionStatusSchema, verdictSchema, MAX_SOURCE_CODE_BYTES, } from "./domain.js";
/** Conta bytes UTF-8, para bater com octet_length() do Postgres. */
export function byteLength(s) {
    return new TextEncoder().encode(s).length;
}
export const createSubmissionSchema = z.object({
    language: languageSchema,
    sourceCode: z
        .string()
        .min(1, "O codigo nao pode estar vazio")
        .refine((s) => s.trim().length > 0, "O codigo nao pode estar vazio")
        .refine((s) => byteLength(s) <= MAX_SOURCE_CODE_BYTES, `O codigo excede ${MAX_SOURCE_CODE_BYTES} bytes`),
});
export const submissionFilterSchema = z.object({
    teamId: z.string().uuid().optional(),
    problemId: z.string().uuid().optional(),
    verdict: verdictSchema.optional(),
    status: submissionStatusSchema.optional(),
    language: languageSchema.optional(),
    limit: z.coerce.number().int().positive().max(200).default(50),
    offset: z.coerce.number().int().nonnegative().default(0),
});
export const rejudgeSchema = z
    .object({
    /** Exigido para rejulgar um problema inteiro com o contest em andamento. */
    confirm: z.boolean().optional(),
})
    .default({});
//# sourceMappingURL=submissions.js.map